import { CustomValidation } from './CustomValidation';
import { Attribute } from './Attribute';
import { ControlLayout } from '../Enums/ControlLayout';
import { FileType } from '../Enums/FileType';
import { FileDTO } from './FileDTO';
import { ImageType } from '../Enums/ImageType';
import { EditPersonalImage } from './EditPersonalImage';
import { SaveDTO } from './SaveDTO';
import { CancelDTO } from './CancelDTO';
import { UploadPersonalImage } from './UploadPersonalImage';
import { ProfilePictureDTO } from './ProfilePictureDTO';

export class ProfileImageUploadOptions {
    /**
 * Represent Name Of Form Control
 */
Name:string
/**
*   Represent classes to textbox that allow us to select the FileInput by jquery or javascript 
*/

ExtraClasses:string

/**  Represent value of the label*/
LabelValue:string
 /**  Represent Key of the label*/
 LabelKey:string
/**  Represent value of the labelDescription show under FileInput*/
LabelDescription:string
/**To set  value  to FileInput */
Value:ProfilePictureDTO
/**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */ 
  ShowAsterisk: boolean
  /** Ability to set  FileInput required */
  IsRequired: boolean
  /** Ability to display or hide the label of FileInput */
  HideLabel:  boolean
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
  */
  AllowDropZone:boolean=false
  CustomValidation: CustomValidation[]=[]
    /** Set List of Custom Attribute to FileInput  */
  AttributeList:Attribute[]
  /** Set File MaxSize In MB  */
  FileMaxSizeInMB: number;
  /**  to set type of view  if FileInput is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
   /** Set List of Custom Attribute to FileInput  */
   ImageUploadAcceptsTypes:ImageType[]=[ImageType.ImageTypes]
   /** Set Default Image  */
   DefaultImageSrc:string
   /** Set ImageID Encrypted    */
   ImageIDEncrypted:string
   /** Set EditPersonalImage     */
   EditPersonalImageTitle:EditPersonalImage
   /** Set SaveDTO     */
   SaveTitle:SaveDTO
   /** Set CancelDTO     */
   CancelTitle:CancelDTO
   /** Set UploadPersonalImage     */
   UploadPersonalImageTitle:UploadPersonalImage
  }
  